/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async listIncomeAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("income/accounts/list", data);
    return response;
  },

  async listPaymentAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("income/payment-accounts/list", data);
    return response;
  },

  async addIncome(
    paymentAccount,
    targetAccount,
    amount,
    transactionDate,
    description,
    payee,
    transactionRef,
    tag
  ) {
    let data = {
      trail_account: paymentAccount,
      target_account: targetAccount,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("income/add", data);
    return response;
  },

  async getIncomeBalance() {
    let data = { source: "Web" };
    let response = await apiCall("income/balance", data);
    return response;
  },

  async listIncomeBalances() {
    let data = { source: "Web" };
    let response = await apiCall("income/balances/list", data);
    return response;
  },
};
